import { CommandBarButton } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { routes } from "../../config/routes";
import { useSelector } from "../../store/hooks";

type Props = {
  text?: string;
  onClick?: () => void;
  isDisabled?: boolean;
  path?: string;
};

const backBtnStyle = {
  root: {
    height: "100%",
  },
};

export const BackButton = ({ text, onClick, isDisabled, path }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const clientId = useSelector((s) => s.clients.clientId);

  const goTo = () => {
    navigate(routes.locations.getPath(clientId));
  };
  const buttonText = t(text || "rvm.backToLocations.label");
  return (
    <CommandBarButton
      iconProps={{ iconName: "Back" }}
      onClick={goTo}
      styles={backBtnStyle}
      text={buttonText}
      disabled={isDisabled}
    />
  );
};
